/* ============================================================
   CHRONCES — « Lire la suite » sur les avis Judge.me

   Les cartes du carrousel ont une hauteur FIXE, calculée en JavaScript par le
   widget : la plupart des avis y sont coupés en plein milieu (mesuré le
   2026-08-02 : 5 avis sur 6, dont un de 292 caractères réduit à deux lignes).

   🚨 Pourquoi une fenêtre et pas un dépliage sur place : testé en direct, forcer
   la carte en `height: auto` ne change RIEN — le conteneur du carrousel porte sa
   propre hauteur en pixels, posée par le widget. Déplier demanderait de défaire
   sa mise en page à chaque redimensionnement. La fenêtre, elle, ne touche à rien.

   Le bouton n'apparaît QUE sur les avis réellement coupés.
   ============================================================ */

class CrJudgemeReadMore {
  constructor() {
    this.dialog = null;
    this.start();
  }

  start() {
    const racine = document.querySelector('.jdgm-widget.jdgm-cards-carousel');
    if (!racine) return;

    /* 🚨 UN SEUL écouteur, sur la racine, et surtout pas un par bouton.
       Le carrousel duplique ses cartes avec `cloneNode` pour boucler à l'infini,
       et un nœud cloné NE GARDE PAS ses écouteurs : les boutons des clones — la
       majorité de ceux qu'on voit — étaient inertes. La délégation y est immune,
       puisque l'écouteur vit sur un ancêtre qui, lui, n'est jamais cloné. */
    racine.addEventListener('click', (event) => {
      const bouton = event.target.closest('.cr-jdgm-more');
      if (!bouton || !racine.contains(bouton)) return;
      event.preventDefault();
      event.stopPropagation();
      this.ouvrir(bouton.closest('.jdgm-card'));
    });

    this.scan(racine);

    /* Le widget rend ses cartes de façon asynchrone et en clone pour boucler :
       sans observateur, on n'équiperait que celles présentes au chargement. */
    this.observer = new MutationObserver(() => this.scan(racine));
    this.observer.observe(racine, { childList: true, subtree: true });
  }

  scan(racine) {
    racine.querySelectorAll('.jdgm-card').forEach((carte) => this.equiper(carte));
  }

  equiper(carte) {
    // Même garde que le bundle builder : sans marqueur, l'observateur repasse
    // sur les cartes déjà traitées et empile les boutons.
    if (carte.dataset.crMore) return;
    const zone = carte.querySelector('.jdgm-text');
    if (!zone) return;
    carte.dataset.crMore = '1';

    const paragraphe = zone.querySelector('p') || zone;
    const coupe =
      zone.scrollHeight > zone.clientHeight + 2 ||
      paragraphe.scrollHeight > paragraphe.clientHeight + 2;
    if (!coupe) return;

    // Pas d'écouteur ici : il est délégué à la racine (voir `start`).
    const bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'cr-jdgm-more';
    bouton.textContent = 'Lire la suite';
    zone.appendChild(bouton);
  }

  /* ---------- La fenêtre ---------- */
  construireDialogue() {
    if (this.dialog) return this.dialog;

    const dialog = document.createElement('dialog');
    dialog.className = 'cr-jdgm-modal';
    dialog.innerHTML = `
      <button type="button" class="cr-jdgm-modal__close" aria-label="Fermer">✕</button>
      <div class="cr-jdgm-modal__stars" data-stars aria-hidden="true"></div>
      <p class="cr-jdgm-modal__text" data-text></p>
      <div class="cr-jdgm-modal__foot">
        <span class="cr-jdgm-modal__name" data-name></span>
        <span class="cr-jdgm-modal__product" data-product></span>
      </div>
      <img class="cr-jdgm-modal__media" data-media alt="" hidden>
    `;
    dialog.querySelector('.cr-jdgm-modal__close').addEventListener('click', () => dialog.close());
    // Clic sur le voile : la cible est le <dialog> lui-même, jamais son contenu.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    document.body.appendChild(dialog);
    this.dialog = dialog;
    return dialog;
  }

  ouvrir(carte) {
    const dialog = this.construireDialogue();
    const texte = carte.querySelector('.jdgm-text');
    const nom = carte.querySelector('.jdgm-reviewer-name');
    const produit = carte.querySelector('.jdgm-product-name');
    const etoiles = carte.querySelector('.jdgm-stars');
    const image = carte.querySelector('img');

    dialog.querySelector('[data-text]').textContent = texte ? texte.textContent.trim() : '';
    dialog.querySelector('[data-name]').textContent = nom ? nom.textContent.trim() : '';
    dialog.querySelector('[data-product]').textContent = produit ? produit.textContent.trim() : '';

    const zoneEtoiles = dialog.querySelector('[data-stars]');
    zoneEtoiles.innerHTML = '';
    if (etoiles) zoneEtoiles.appendChild(etoiles.cloneNode(true));

    const media = dialog.querySelector('[data-media]');
    if (image && image.currentSrc) {
      media.src = image.currentSrc;
      media.hidden = false;
    } else {
      media.removeAttribute('src');
      media.hidden = true;
    }

    dialog.showModal();
  }
}

const demarrer = () => new CrJudgemeReadMore();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', demarrer);
} else {
  demarrer();
}
